/* The credits (see credits.tsx), over the title screen. */

.credits {
  position: fixed;
  inset: 0;
  display: grid;
  place-items: center;
  background: rgba(255, 246, 235, 0.55);
  backdrop-filter: blur(3px);
  z-index: 10;
}

.card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: min(460px, calc(100vw - 32px));
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
  padding: 18px 22px 20px;
  border-radius: 24px;
  background: var(--panel);
  border: 1px solid var(--line);
  box-shadow: 0 12px 40px rgba(120, 80, 50, 0.15);
  animation: rise-in 0.3s ease-out;
}

@keyframes rise-in {
  0% {
    opacity: 0;
    transform: translateY(10px) scale(0.96);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}

.heading {
  margin: 0;
  font-size: 20px;
  text-align: center;
}

.logo {
  display: block;
  width: min(300px, 80%);
  height: auto;
  margin: 0 auto;
}

.staff {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 4px 14px;
  margin: 0;
  font-size: 14px;
}

.staff dt {
  font-weight: 700;
  color: var(--ink-soft);
}

.staff dd {
  margin: 0;
}

.groupTitle {
  margin: 4px 0 -4px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: var(--ink-soft);
}

.libraries {
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.libraries li {
  padding: 8px 12px;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: #fffaf3;
}

.libraryHead {
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-size: 14px;
}

.libraryHead a {
  font-weight: 700;
  color: var(--ink);
}

.libraryHead span {
  font-size: 12px;
  color: var(--ink-soft);
}

.license {
  margin-left: auto;
  padding: 1px 8px;
  border-radius: 99px;
  background: var(--accent-soft);
  color: var(--accent);
  font-weight: 700;
}

.text summary {
  margin-top: 4px;
  font-size: 12px;
  color: var(--ink-soft);
  cursor: pointer;
}

.text p {
  margin: 6px 0 0;
  font-size: 11px;
  line-height: 1.5;
  color: var(--ink-soft);
  user-select: text;
}

.actions button {
  flex: 1;
}
